module.exports = __webpack_public_path__ + "static/media/image4.4a26bc1a.jpg";